const SvgSoftware3 = (props) => (
  <>
    <path d="M96 96 48 48 96 0v96zM0 0l48 48L0 96V0z" fill={props.p40} />
  </>
);

export default SvgSoftware3;
